export const HB_OVERVIEW_FILTER = 'hbOverviewFilter';
export const HB_FLOWS_FILTER = 'hbFlowsFilter';
export const HB_FLOW_TRACES_FILTER = 'hbFlowTracesFilter';
export const HB_RESOURCES_FILTER = 'hbResourcesFilter';
export const HB_DYNAMIC_TABLE_FILTER = 'hbDynamicTableFilter';
export const HB_SECRETS_FILTER = 'hbSecretsFilter';
export const HB_SERVICE_ACCOUNTS_FILTER = 'hbServiceAccountsFilter';
export const HB_ALERTS_FILTER = 'hbAlertsFilter';
export const HB_BEATBOX_FILTER = 'hbBeatboxFilter';
export const HB_REPORTING_FILTER = 'hbReportingFilter';
export const HB_AGENTS_FILTER = 'hbAgentsFilter';
export const HB_CERTIFICATES_FILTER = 'hbCertificatesFilter';

export const FILTERS = {
  HB_OVERVIEW_FILTER,
  HB_FLOWS_FILTER,
  HB_FLOW_TRACES_FILTER,
  HB_RESOURCES_FILTER,
  HB_DYNAMIC_TABLE_FILTER,
  HB_SECRETS_FILTER,
  HB_SERVICE_ACCOUNTS_FILTER,
  HB_ALERTS_FILTER,
  HB_BEATBOX_FILTER,
  HB_REPORTING_FILTER,
  HB_AGENTS_FILTER,
  HB_CERTIFICATES_FILTER,
};
